// React
import { useState, useEffect, useRef, useContext } from "react";

// Components and styled components
import { ReactComponent as StarIcon } from "./star.svg";
import { SingleStar, KanbanStars } from "./KanbanCardStars.styled";

// Context
import { useKanbanDispatch } from "../../../../../context/KanbanContext";
import { DispatchPositionContext } from "../../../../../context/PositionContext";

/**
 * This component can be disabled ( shared shortlist ), unset ( no star rating given ) or has stars 1 - 5
 * @returns jsx
 */
const KanbanCardStars = ({ application, disabled }) => {
  const { updateCompactApplication } = useKanbanDispatch();
  const positionDispatch = useContext(DispatchPositionContext);
  const [rating, setRating] = useState(application.stars || 0);
  const [tempRating, setTempRating] = useState(application.stars || 0);
  // Ref tracks the committed rating synchronously so mouse-out never reads a stale closure value
  const committedRatingRef = useRef(application.stars || 0);

  useEffect(() => {
    const stars = application.stars || 0;
    setRating(stars);
    setTempRating(stars);
    committedRatingRef.current = stars;
  }, [application.stars]);

  return (
    <KanbanStars disabled={disabled}>
      <span>
        {[1, 2, 3, 4, 5].map((i) => {
          return (
            <Star
              key={i}
              starNum={i}
              rating={rating}
              isOn={i <= tempRating}
              setRate={setRating}
              setTempRate={setTempRating}
              committedRatingRef={committedRatingRef}
              updateCompactApplicationStars={updateCompactApplication}
              applicationId={application.id}
              updateSelectedApplication={positionDispatch}
              disabled={disabled}
            />
          );
        })}
      </span>
    </KanbanStars>
  );
};

export default KanbanCardStars;

const Star = ({ starNum, isOn, rating, setRate, disabled, setTempRate, committedRatingRef, updateCompactApplicationStars, applicationId, updateSelectedApplication }) => {
  const handleMouseOver = () => {
    if (disabled) {
      return;
    }
    setTempRate(starNum);
  };

  const handleMouseClick = (event) => {
    event.stopPropagation(); // Prevent click from bubbling up to the card's onClick
    if (disabled) {
      return;
    }
    const newRate = committedRatingRef.current === starNum ? 0 : starNum;
    // Update ref synchronously before any async state update so handleMouseOut is never stale
    committedRatingRef.current = newRate;
    setRate(newRate);
    setTempRate(newRate);
    updateCompactApplicationStars({ applicationId, stars: newRate });
    updateSelectedApplication({
      type: "update_selected_application",
      payload: { id: applicationId, stars: newRate },
    });
  };

  const handleMouseOut = () => {
    // Use ref instead of the `rating` prop to avoid stale closure after a click
    setTempRate(committedRatingRef.current);
  };

  return (
    <SingleStar isOn={isOn} onClick={handleMouseClick} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
      <StarIcon />
    </SingleStar>
  );
};
